import { useUserMe } from './user/useUserMe';

export function useBuildQueryKey() {
  const { selectedTenantId } = useUserMe();

  return {
    buildQueryKey: (queryKey: string | Array<string | undefined>) => [
      selectedTenantId,
      ...(Array.isArray(queryKey) ? queryKey : [queryKey ?? '']),
    ],
  };
}
